var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      staticClass: "sl-modal",
      attrs: { id: "confirmModak", maximized: false, value: _vm.isOpen },
      on: { hide: _vm.closeModal }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c(
                "q-toolbar-title",
                [
                  _c("q-icon", { attrs: { name: "fa fa-info-circle" } }),
                  _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")
                ],
                1
              ),
              _c("q-icon", {
                attrs: { name: "clear" },
                nativeOn: {
                  click: function($event) {
                    return _vm.closeModal($event)
                  }
                }
              })
            ],
            1
          ),
          _c("div", { staticStyle: { padding: "20px" } }, [
            _c("strong", [_vm._v(_vm._s(_vm.body))])
          ]),
          _c(
            "q-toolbar",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("q-toolbar-title"),
              _c("q-btn", {
                attrs: { color: "blue", label: _vm.buttonText },
                nativeOn: {
                  click: function($event) {
                    return _vm.closeModal($event)
                  }
                }
              }),
              _vm._v(" \n  ")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }